import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Sector } from "@modules/bookSectors/types";
import { ListSectorsQueryFilters } from "./types";

export async function getSectorsService(filters?: ListSectorsQueryFilters): Promise<Sector[]> {
  try {
    const { data } = await api.get<ApiResponse<Sector>>(`v1/book_sector_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        ordering: "-id",
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching book categories:", error);
    throw error;
  }
}
